import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ID_ANI } from "@shared/constants/risk-item-fields.constants";
import { Declaration } from "@shared/enums/contract.enum";
import { PolicyFields } from "@shared/enums/policy-fields.enum";
import {
  getDropdownClass,
  getInputClass,
  getInputMaskClass,
  getIsEditable,
  getIsVisible,
} from "@shared/helpers/contract-edition.helper";
import { PolicyDetail } from "@shared/models/policy-details";
import { PolicyFieldsVM } from "@shared/models/policy-field-vm.model";

@Component({
  selector: "app-contract-detail-sa-contract-informations",
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./contract-detail-sa-contract-informations.component.html",
  styleUrls: [],
})
export class ContractDetailContractInformationsComponent implements OnInit {
  @Input() policyFieldsVM!: PolicyFieldsVM;
  @Input() policyDetails!: PolicyDetail;
  @Input() policyDetailsCopy!: PolicyDetail;
  @Input() hasEndorsementWait4Sign!: boolean;

  @Output() emitFormValidity = new EventEmitter<number>();
  @Output() emitFormValidityChange = new EventEmitter<{ isValid: boolean; values: { key: string; value: string }[] }>();

  PolicyFields = PolicyFields;
  Declaration = Declaration;

  getIsVisible = getIsVisible;
  getIsEditable = getIsEditable;
  getInputClass = getInputClass;
  getDropdownClass = getDropdownClass;
  getInputMaskClass = getInputMaskClass;

  // FORM GROUP
  contractFormGroup = new FormGroup<{
    identificationNumber: FormControl<string | null>;
  }>({
    identificationNumber: new FormControl<string | null>(null, [Validators.pattern(/^[a-zA-Z0-9]{1,15}$/)]),
  });

  constructor() {}

  ngOnInit() {
    this.contractFormGroup.controls.identificationNumber.setValue(
      this.policyDetails.riskItemInformations.values.find(item => item.code === ID_ANI)?.value ?? null
    );
    this.contractFormGroup.controls.identificationNumber.markAsPristine();
    this.contractFormGroup.controls.identificationNumber.markAsUntouched();

    this.contractFormGroup.controls.identificationNumber.valueChanges.subscribe(value => {
      this.policyDetailsCopy.riskItemInformations.values.find(item => item.code === ID_ANI)!.value = value ?? "";
      if (this.contractFormGroup.controls.identificationNumber.valid) {
        this.emitFormValidityChange.emit({
          isValid: this.contractFormGroup.valid,
          values: [{ key: "identificationNumber", value: value ?? "" }],
        });
      }
    });
  }
}
